/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedHeadLinkTags_metadata$ref = any;
export type SharedHeadLinkTags_metadata = {
    readonly canonical: string | null;
    readonly disableIndexing: boolean | null;
    readonly next: string | null;
    readonly prev: string | null;
    readonly " $refType": SharedHeadLinkTags_metadata$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SharedHeadLinkTags_metadata",
    "type": "MetaData",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "canonical",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "disableIndexing",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "next",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "prev",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'fe44edbfd9fb00feb7d3dea57ccd37d2';
export default node;
